import React, { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";
import { OverlayPanel } from "primereact/overlaypanel";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import { DialogActions, TextField } from "@material-ui/core";
import { Card } from "react-bootstrap";
import {
  getItemsMovement,
  uploadItemsStock,
} from "../../../../../services/inventory/itemsMovement";
import Illustration from "../../../../../partials/content/Illustration";
import { formatDate } from "../../../../../utils/utils";
import ItemsMovementForm from "./itemsMovementForm";
import { DropzoneAreaBase } from "material-ui-dropzone";
import ConfirmUploadedStocksForm from "./confirmUploadedStocksForm";
import { apiUrl } from "../../../../../../config.js";
import { getFileExtension } from "../../../../../utils/utils";
import { FileIcon, defaultStyles } from "react-file-icon";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
function ItemsMovementList({
  warehouseID: warehouseIDprop = 0,
  outletID: outletIDprop = 0,
  match,
  withMenu = true,
}) {
  const { reload } = useGlobalData();
  const selectParamOp = useRef(null);
  const [openUploadFile, setOpenUploadFile] = useState(false);
  const [files, setFiles] = useState([]);
  const [selectParam, setSelectParam] = useState({
    fiscalYear: DateTime.now().year,
    fiscalPeriod: DateTime.now().month,
  });
  const [itemsMovement, setItemsMovement] = useState([]);
  const [uploadedStocks, setUploadedStocks] = useState([]);
  const [showUploadedStock, setShowUploadedStock] = useState(false);
  const [openItemsMovementForm, setOpenItemsMovementForm] = useState(false);
  const handlePreviewIcon = (fileObject, classes) => {
    const { name } = fileObject.file;
    return (
      <div
        style={{
          WebkitFontSmoothing: "antialiased",
          width: "40px",
          margin: "auto",
        }}
      >
        <FileIcon
          extension={getFileExtension(name)}
          {...defaultStyles[`${getFileExtension(name)}`]}
          labelUppercase
        />
      </div>
    );
  };
  let warehouseID = 0;
  let outletID = 0;
  if (warehouseIDprop > 0) {
    warehouseID = warehouseIDprop;
  } else if (outletIDprop > 0) {
    outletID = outletIDprop;
  } else {
    const { warehouseID: warehouseIDparam = 0 } = match.params;
    const { outletID: outletIDparam = 0 } = match.params;
    if (warehouseIDparam > 0) {
      warehouseID = parseInt(warehouseIDparam);
    } else if (outletIDparam > 0) {
      outletID = parseInt(outletIDparam);
    }
  }

  useEffect(() => {
    if (selectParam.fiscalYear > 0 && selectParam.fiscalPeriod > 0) {
      getItemsMovementData();
    }
  }, [reload]);

  async function getItemsMovementData() {
    const response = await getItemsMovement(
      warehouseID,
      outletID,
      0,
      "",
      0,
      selectParam.fiscalYear,
      selectParam.fiscalPeriod
    );
    const { data } = response.data;
    setItemsMovement(data.itemsMovement);
  }
  return (
    <React.Fragment>
      <OverlayPanel
        ref={selectParamOp}
        showCloseIcon
        dismissable={false}
        id="overlay_panel"
        style={{ width: "450px" }}
        className="overlaypanel-demo"
      >
        <div className="row mb-3">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <Card>
              <Card.Header>
                <i className="fas fa-filter"></i>
                <span>
                  <strong>Filter Selection</strong>
                </span>
              </Card.Header>
              <Card.Body>
                <div className="row">
                  <div className="col-6">
                    <TextField
                      id="fiscalYear"
                      label="Fiscal Year"
                      type="number"
                      value={selectParam.fiscalYear}
                      variant="outlined"
                      size="small"
                      onChange={(e) => {
                        const selectParamTmp = { ...selectParam };
                        selectParamTmp.fiscalYear = e.target.value;
                        setSelectParam(selectParamTmp);
                      }}
                    />
                  </div>
                  <div className="col-6">
                    <TextField
                      id="fiscalPeriod"
                      label="Fiscal Period"
                      type="number"
                      value={selectParam.fiscalPeriod}
                      variant="outlined"
                      size="small"
                      onChange={(e) => {
                        if (e.target.value < 1 || e.target.value > 12) {
                          e.target.value = 1;
                        }
                        const selectParamTmp = { ...selectParam };
                        selectParamTmp.fiscalPeriod = e.target.value;
                        setSelectParam(selectParamTmp);
                      }}
                    />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <button
              type="button"
              className="btn btn-success btn-md btn-pill btn-bold float-right"
              onClick={() => {
                if (
                  selectParam.fiscalYear > 0 &&
                  selectParam.fiscalPeriod > 0
                ) {
                  getItemsMovementData();
                }
              }}
            >
              <i className="fas fa-search"></i>
              Get Items Movement
            </button>
          </div>
        </div>
      </OverlayPanel>
      {itemsMovement.length ? (
        <React.Fragment>
          <CustomDataTable
            data={itemsMovement}
            buttons={
              withMenu
                ? [
                    {
                      name: "Filter",
                      onClick: (e) => {
                        selectParamOp.current.toggle(e);
                      },
                      icon: "fas fa-search",
                      color: "info",
                    },
                    {
                      name: "Stock Entries",
                      onClick: (e) => {
                        setOpenItemsMovementForm(true);
                      },
                      icon: "fas fa-parachute-box",
                      color: "primary",
                    },
                    {
                      name: "Mass Upload",
                      onClick: (e) => {
                        setOpenUploadFile(true);
                      },
                      icon: "fas fa-upload",
                      color: "primary",
                    },
                  ]
                : [
                    {
                      name: "Filter",
                      onClick: (e) => {
                        selectParamOp.current.toggle(e);
                      },
                      icon: "fas fa-search",
                      color: "info",
                    },
                  ]
            }
            onRefreshData={() => {
              if (selectParam.fiscalYear > 0 && selectParam.fiscalPeriod > 0) {
                getItemsMovementData();
              }
            }}
            columns={[
              {
                header: "Movement Date",
                field: "moveDate",
                body: (rowData) => <>{formatDate(rowData.moveDate)}</>,
                sortable: true,
                filter: true,
              },
              {
                header: "Item Type",
                field: "itemTypeName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.itemTypeName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Item Code",
                field: "itemCode",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.itemType > 0 ? (
                      <span>
                        <BootstrapTooltip title={rowData.itemTypeName}>
                          <span className="mr-2">
                            <i
                              className={
                                rowData.itemType === 1
                                  ? "fas fa-boxes text-success"
                                  : rowData.itemType === 2
                                  ? "fas fa-tools text-primary"
                                  : rowData.itemType === 3
                                  ? "fas fa-building text-info"
                                  : rowData.itemType === 4
                                  ? "fas fa-boxes text-warning"
                                  : rowData.itemType === 5
                                  ? "fas fa-boxes text-danger"
                                  : null
                              }
                            ></i>
                          </span>
                        </BootstrapTooltip>
                        <span>
                          <ResponsiveEllipsis
                            text={rowData.itemCode}
                            maxLine="1"
                            displayInline
                          />
                        </span>
                      </span>
                    ) : (
                      <React.Fragment>
                        <ResponsiveEllipsis
                          text={rowData.itemCode}
                          maxLine="1"
                        />
                      </React.Fragment>
                    )}
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Item Name",
                field: "itemName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.itemName} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Document Reference",
                field: "docRef",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Document Reference ID",
                field: "docID",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Source Location",
                field: "source",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.source} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Destination Location",
                field: "destination",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.destination}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Quantity",
                field: "qty",
                body: (rowData) => (
                  <>
                    {rowData.moveType === 101 ? (
                      <span className="text-success">{`+ ${rowData.qty}`}</span>
                    ) : rowData.moveType === 102 ? (
                      <span className="text-danger">{`- ${rowData.qty}`}</span>
                    ) : null}
                  </>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Unit",
                field: "uom.uomName",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Batch ID",
                field: "batchID",
                body: null,
                sortable: true,
                filter: true,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Inventory.png"
            description={`You don't have any Items Movement during Fiscal Period ${
              selectParam.fiscalPeriod
            } Year ${selectParam.fiscalYear} inside this ${
              warehouseID > 0 ? "Warehouse" : outletID > 0 ? "Outlet" : null
            }!`}
            guidance={`Hint: once the items movement happens inside this ${
              warehouseID > 0 ? "warehouse" : outletID > 0 ? "outlet" : null
            }, it will be displayed here. Try to filter another period to get some results`}
            descriptionLeftIcon="fas fa-info-circle kt-font-info"
            size="md"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-info btn-md btn-pill btn-bold mx-1"
              onClick={(e) => {
                selectParamOp.current.toggle(e);
              }}
            >
              <i className="fas fa-search"></i>
              Filter
            </button>
            <button
              type="button"
              className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
              onClick={(e) => {
                setOpenItemsMovementForm(true);
              }}
            >
              <i className="fas fa-parachute-box"></i>
              Stock Entries
            </button>
            <button
              type="button"
              className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
              onClick={(e) => {
                setOpenUploadFile(true);
              }}
            >
              <i className="fas fa-upload"></i>
              Mass Upload
            </button>
          </div>
        </React.Fragment>
      )}
      <DialogLayout
        open={openItemsMovementForm}
        title="Manual Stock Entries Form"
        onCloseDialog={() => {
          setOpenItemsMovementForm(false);
        }}
        maxWIdth="lg"
      >
        <ItemsMovementForm
          warehouseID={warehouseID}
          outletID={outletID}
          onConfirmSave={() => {
            if (selectParam.fiscalYear > 0 && selectParam.fiscalPeriod > 0) {
              getItemsMovementData();
            }
            setOpenItemsMovementForm(false);
          }}
          onCloseDialog={() => {
            setOpenItemsMovementForm(false);
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openUploadFile}
        title="Mass Upload Stock Form"
        onCloseDialog={() => {
          setOpenUploadFile(false);
        }}
        maxWIdth={showUploadedStock ? "lg" : "md"}
      >
        {showUploadedStock ? (
          <ConfirmUploadedStocksForm
            uploadedItemsStocks={uploadedStocks}
            showUploadedStock={showUploadedStock}
            setOpenUploadFile={setOpenUploadFile}
            setShowUploadedStock={setShowUploadedStock}
            onConfirmSave={() => {
              if (selectParam.fiscalYear > 0 && selectParam.fiscalPeriod > 0) {
                getItemsMovementData();
              }
              setOpenUploadFile(false);
            }}
          />
        ) : (
          <DropzoneAreaBase
            fileObjects={files}
            maxFileSize={10000000}
            filesLimit={1}
            acceptedFiles={[
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            ]}
            getPreviewIcon={handlePreviewIcon}
            onAdd={(newFile) => {
              setFiles([].concat(files, newFile));
            }}
            onDelete={(deleteFile) => {
              const fileList = [...files];
              fileList.map((file, indexFile) => {
                if (file.data === deleteFile.data) {
                  if (indexFile !== -1) {
                    fileList.splice(indexFile, 1);
                  }
                }
              });
              setFiles(fileList);
            }}
            showPreviewsInDropzone={true}
            showFileNames={true}
            dropzoneText="Drag and drop a file here or click. Please use Items Stock mass upload template provided"
          />
        )}
        {!showUploadedStock ? (
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={() => {
                setOpenUploadFile(false);
              }}
            >
              <i className="fas fa-window-close"></i>
              Close
            </button>
            <a
              href={apiUrl + "/commons/download-items-stock-template"}
              target="_blank"
              rel="noopener noreferrer"
              download
            >
              <button
                type="button"
                className="btn btn-label-info btn-md btn-pill btn-bold"
                onClick={() => {}}
              >
                <i className="fas fa-cloud-download-alt"></i>
                Download Items Stock Template
              </button>
            </a>
            <button
              type="button"
              className="btn btn-success btn-md btn-pill btn-bold"
              onClick={() => {
                uploadExcelFile();
              }}
            >
              <i className="fas fa-spell-check"></i>
              Verify & Upload
            </button>
          </DialogActions>
        ) : null}
      </DialogLayout>
    </React.Fragment>
  );

  function uploadExcelFile() {
    if (files.length === 1) {
      Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success btn-md btn-pill btn-bold",
          cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
        },
        buttonsStyling: false,
      })
        .fire({
          title:
            "Are you sure want to upload this file as Items Stock mass upload source?",
          text:
            "Please make sure all the input data is correct based on Invifo upload template",
          icon: "question",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, upload it`,
          cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            const filesData = new FormData();
            for (const file of files) {
              filesData.append("files[]", file.file);
            }
            filesData.append("warehouseID", warehouseID);
            filesData.append("outletID", outletID);
            setFiles([]);

            uploadItemsStock(filesData).then((response) => {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Uploaded",
                html: response.data.message,
                icon: "success",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
              const { data } = response.data;
              setFiles([]);
              setUploadedStocks(data.uploadItemsStocks);
              setShowUploadedStock(true);
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Cancelled",
              text: "No change has been made",
              icon: "info",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
          }
        });
    } else {
      Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        },
        buttonsStyling: false,
      }).fire({
        title: "Failed",
        text: "Please upload a file",
        icon: "error",
        showCloseButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
      });
    }
  }
}

export default ItemsMovementList;
